import { combineReducers } from 'redux'
import formReducer from './formReducer'
import dataReducer from './dataReducer'

export default combineReducers({
    formReducer,
    dataReducer,
})
